// DLC Client Config
// import { isProd } from "../env";
import template from "./_template";

const aep_config = {
  name: "aep",
  disabled_features: {
    ...template.disabled_features,
    email: true,
  },
  enabled_features: {
    ...template.enabled_features,
    dataset_dip: true, // DLC-147 Whether to ENABLE client to "dip" datasets to find mobile phone numbers
    dataset_import: true,
    sso_microsoft: true, // Whether Login page should display the Microsoft SSO button
    campaign_templates: true, // Whether to ENABLE the templates feature for the client DLC-78
    suppression_list: ["sms", "voice"],
  },
  sms: {
    short_codes: [
      // { label: "94230", value: "94230" }, // REST DLC-109 Removed as certification has completed for their shortcodes
      { label: "SC # 57206", value: "57206" },
      // { label: "TXTDLC - Billing", value: "898352" }, // DLC-109 Removed as this SC intended as Billing, not Ad Hoc
    ],
  },
  voice: {
    premium_options: ["spanish"], // "all" || "premium" | "french" | "german" | "spanish"
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { label: "Kingsport Power TN 01: 800-967-4237", value: "8009674237" },
      { label: "Appalachian Power VA 02: 800-956-4237", value: "8009564237" },
      { label: "Appalachian Power WV 02: 800-982-4237", value: "8009824237" },
      { label: "Kentucky Power KY 03: 800-572-1113", value: "8005721113" },
      { label: "Indiana Michigan Power IN 04: 800-311-4634", value: "8003114634" },
      { label: "Indiana Michigan Power MI 04: 800-311-6424", value: "8003116424" },
      { label: "Wheeling Power WV 06: 800-852-6942", value: "8008526942" },
      { label: "AEP Ohio OH 07 & 10: 800-672-2231", value: "8006722231" },
      { label: "AEP Texas TX 94 & 97: 866-223-8508", value: "8662238508" },
      { label: "PSC Oklahama OK 95: 833-776-6884", value: "8337766884" },
      { label: "SWEPCO LA, TX & AR 96: 888-218-3919", value: "8882183919" },
    ],
  },
};

export default aep_config;
